import { cardTitle } from '../../assets/jss/wisene-material-dashboard-pro-react-types';
import { connect } from 'react-redux';
import { setServiceMode } from '../../stores/actions/dashboardActions';
import Button from '../../../components/CustomButtons/ButtonTS';
import Card from '../../../components/Card/CardTS';
import CardHeader from '../../../components/Card/CardHeader';
import CardBody from '../../../components/Card/CardBody';
import CardIcon from '../../../components/Card/CardIcon.js';
import dashboardStyle from '../../assets/jss/views/dashboardStyleTS';
import Loading from '../../components/Loading/Loading';
import ErrorComponent from '../ErrorComponent/ErrorComponent';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import React from 'react';
import styles from '../../assets/jss/views/dashboardStyle';
import {useState, useEffect} from 'react';
import Build from '@material-ui/icons/Build';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

const style = {
	cardTitle,
	cardCategory: styles.cardCategory,
};

const DEFAULT_DURATION_HOURS = 6;
const DURATION_HOURS_OPTIONS = Array.from({ length: 12 }, (_, i) => i + 1);

interface IServiceModeCardProps {
	hideAlert: () => void;
    mobileView: boolean;
	systemID: number;
    serviceModeEnd: string;
    serviceModeNow: boolean;
    serviceModeSettingSuccess: boolean;
    serviceModeSettingFailed: boolean;
    setServiceMode: (systemID: number, on: boolean, durationHours?: number) => void;
}

const ServiceModeCard  = (props: IServiceModeCardProps) => {
    const {hideAlert, systemID, serviceModeEnd, serviceModeNow, setServiceMode, serviceModeSettingSuccess,
           serviceModeSettingFailed} = props;
    const [submitted, setSubmitted] = useState(false);
    const [durationHours, setDurationHours] = useState(DEFAULT_DURATION_HOURS);

    useEffect(() => {
        if (serviceModeSettingSuccess) {
            hideAlert();
        }
    }, [serviceModeSettingSuccess]);

    const onSubmitOn = () => {
        setSubmitted(true);
        setServiceMode(systemID, true, durationHours);
    };

    const onSubmitOff = () => {
        setSubmitted(true);
        setServiceMode(systemID, false);
    };

    const durationSelect = (
        <TextField
            select
            id='serviceModeDurationHours'
            label={serviceModeNow ? 'New duration' : 'Duration'}
            value={durationHours}
            onChange={(e) => setDurationHours(Number(e.target.value))}
            style={{ minWidth: '160px' }}
            SelectProps={{ MenuProps: { style: { zIndex: 6000 } } }}
        >
            {DURATION_HOURS_OPTIONS.map((hours) => (
                <MenuItem key={hours} value={hours}>{hours} {hours === 1 ? 'hour' : 'hours'}</MenuItem>
            ))}
        </TextField>
    );

    const buttons = () => {
        if (submitted && !serviceModeSettingSuccess && !serviceModeSettingFailed) {
            return (
                <div style={{ width: '100%', marginTop: '25px', marginBottom: '10px', paddingLeft: '10px', paddingTop: '5px' }}>
                    <Loading transform={1} height={17} width={40} color='darkGray' />
                </div>);
        }
        if (serviceModeNow) {
            return (
                <>
                    <Button color='info' onClick={onSubmitOn} className='downloadButton'>Update</Button>
                    <Button color='danger' onClick={onSubmitOff} className='downloadButton'>Turn off</Button>
                </>
            );
        }
        return <Button color='info' onClick={onSubmitOn} className='downloadButton'>Turn on</Button>;
    }

    return (
        <ErrorComponent Children message='Error'>
            <Card chart style={{ overflow: 'visible', marginTop: '10px', marginBottom: '0' }} className='node-edit-card'>
            <CardHeader color='info' icon>
                <CardIcon color='info'>
                   <Build/>
                </CardIcon>
                <h3 style={{ ...style.cardTitle, textAlign: 'left' }}>{"Service mode"}</h3>
            </CardHeader>
            <CardBody>
                <form>
                <GridContainer style={{ margin: '0 0 0 -15px' }}>
                    <GridItem xs={12} style={{ margin: '25px 0 0 0' }}>
                        {serviceModeNow  ? <>
                            <p>Service mode active until:</p>
                            <p>{(new Date(serviceModeEnd).toLocaleString('sv-SE').replace('T', ' '))}</p><br/>
                            </>
                            : <p>Service mode will be activated for the picked duration:</p>}
                    </GridItem>

                    <GridItem xs={12} style={{ margin: '10px 0 0 0' }}>
                        {durationSelect}
                    </GridItem>

                    <GridItem xs={12} style={{ margin: '25px 0 0 0', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                        {buttons()}
                    </GridItem>
                </GridContainer>
                </form>
        </CardBody >
        </Card>
    </ErrorComponent>
    );
}



const mapStateToProps = (state) => {
    return {
        serviceModeSettingSuccess: state.dashboard.serviceModeSettingSuccess,
        serviceModeSettingFailed: state.dashboard.serviceModeSettingFailed,
        serviceModeEnd: state.dashboard.system.serviceModeEnd,
        serviceModeNow: state.dashboard.system.serviceModeNow,
        moblieView: state.dashboard.mobileView
    }
}
const actions = { setServiceMode };
export const ExportCardWithStyles = dashboardStyle(ServiceModeCard);
export default connect(mapStateToProps, actions)(ExportCardWithStyles);
